import React, { useEffect, useRef, useState } from 'react';
import { Divider, FormControl, InputLabel, TextField, Button, Select, MenuItem } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import '../css/modal.css'


const CompanyAdd = ({ token, handleClose, handleRefresh }) => {
    const [loading, setLoad] = useState(false);
    const [helber, setHelber] = useState("");
    const com_name = useRef();
    const com_reg_num = useRef();
    const com_account = useRef();
    const com_phone = useRef();
    const com_bonus_prcnt = useRef();
    const com_bonus_amt = useRef();

    const handleEscape = (e) => {
        if (e.keyCode == 27) {
            handleClose(false);
        }
    }

    useEffect(() => {
        window.addEventListener('keyup', handleEscape);
        return () => {
            window.removeEventListener('keyup', handleEscape);
        }
    }, [handleEscape])

    const handleClick = () => {
        handleClose(false);
    }

    const handleSubmit = () => {
        if (com_name.current.value.trim() == "") {
            alert("Компани нэр заавал оруулна уу.");
            return;
        }
        setLoad(true);
        var req = {
            "com_name": com_name.current.value.trim(),
            "com_reg_num": Number(com_reg_num.current.value) || 0,
            "com_phone": com_phone.current.value,
            "com_account": com_account.current.value,
            "com_bonus_prcnt": Number(com_bonus_prcnt.current.value) || 0,
            "com_bonus_amt": Number(com_bonus_amt.current.value) || 0,
            "com_bonus_helber": helber,
        };

        const request = new Request('https://wms-cloud.com/api/Company', {
        //const request = new Request('http://localhost:8080/Company', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` })
        });

        fetch(request).then((response) => {
            setLoad(false);
            if (response.status == 200) {
                return response.json();
            }
            alert("Амжилтгүй " + response.status);
        }).then((resp) => {
            if (resp) {
                alert("Амжилттай хадгалагдлаа. Компани код: " + resp.com_id);
                handleClose(false);
                handleRefresh();
            }
        });
    }

    return <div className="custmodal">
        <div className="mcont">
            <div className="mheader">
                Компани нэмэх
            <button aria-label="Хаах" onClick={() => handleClick()}>✕</button>
            </div>
            <Divider />
            <div className="mccont">
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <TextField inputRef={com_name} label="Компани нэр" helperText="Компани кодыг автоматаар олгоно" required fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={com_reg_num} type="number" label="Компани регистр" fullWidth ></TextField>
                    </div>
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={com_phone} label="Компани утасны дугаар" fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <TextField inputRef={com_account} label="Компани данс" fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={com_bonus_prcnt} type="number" label="Компани хөнгөлөлт хувь" fullWidth ></TextField>
                    </div>
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={com_bonus_amt} type="number" label="Хөнгөлөлт эдлэх дүн (дээш байвал)" fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <FormControl fullWidth>
                            <InputLabel id="comadd-helber-label">Хөнгөлөлт эдлэх хэлбэр</InputLabel>
                            <Select
                                labelId="comadd-helber-label"
                                value={helber}
                                label="Хөнгөлөлт эдлэх хэлбэр"
                                onChange={(e) => setHelber(e.target.value)}
                            >
                                <MenuItem key={"Бэлэн"} value={"Бэлэн"}>{"Бэлэн"}</MenuItem>
                                <MenuItem key={""} value={""}>{"Бүгд"}</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className="mfooter">
                <Button onClick={handleClick}>Буцах</Button>
                <Button variant="contained" onClick={handleSubmit}>Хадгалах</Button>
            </div>
            {loading ?
                <div className="prodload">
                    <CircularProgress />
                </div> : ""
            }
        </div>
    </div>
}

export default CompanyAdd;
